import React from 'react';
import { Link } from 'react-router-dom';

import Footer from '../../components/Footer';
import ProtectedHeader from '../../components/ProtectedHeader';
import RightArrowIcon from '../../components/RightArrowIcon';

const InternalServerError = () => {
  return (
    <>
      <ProtectedHeader />
      <section>
        <div className="py-20 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="mb-6  p-4 relative pl-0 text-center">
              <h2 className="text-9xl font-bold text-navy-500">500</h2>
              <h3 className="text-4xl font-bold ">Internal server error.</h3>
              <p className="text-gray-500 text-2xl">
                Sorry, some issue occurred.
              </p>
              <p className="text-2xl text-navy-500 hover:text-navy-600 active:text-navy-600">
                <Link to="/">
                  Go back home <RightArrowIcon />
                </Link>
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default InternalServerError;
